import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/ContractBasis/ContractBasis.requests'

type ContractBasisFeesResponse = {
    hasValidAdditionalFees: boolean
}

export default (id: number, enabled: boolean = true) => {
    return useRequest<ContractBasisFeesResponse>({
        key: RequestKeys.getContractBasisHasValidAdditionalFees,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config.hasValidAdditionalFees),
        enabled: Boolean(id) && enabled,
        keepPreviousData: true,
    })
}
